<script>
export default {
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
</script>

<template>
  <button
    type="button"
    class="relative flex-shrink-0 h-5 w-9 p-[2px] border-none shadow-inner w-7 rounded-3xl"
    :class="[
      modelValue ? 'bg-green-500' : 'shadow-ash-400 bg-ash-200',
      disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
    ]"
    role="switch"
    :aria-checked="modelValue.toString()"
    :aria-disabled="disabled.toString()"
    :disabled="disabled"
    @click="onClick"
  >
    <span
      aria-hidden="true"
      class="rounded-full bg-white top-0.5 absolute dark:bg-white w-4 h-4 translate-y-0 duration-200 transition-transform ease-in-out"
      :class="
        modelValue
          ? 'ltr:translate-x-0 rtl:translate-x-[14px]'
          : 'ltr:-translate-x-[14px] rtl:translate-x-0'
      "
    />
  </button>
</template>
